import React, { useEffect } from 'react';
import { useStore } from 'react-redux';
import { ContentState, EditorState } from 'draft-js';
import MessageArea from '../MessageArea/MessageArea';
import { useSubmit } from './SubmitProvider';
import MessageEditor, {
  blockHeading,
  blockList,
  decorators,
  inlineStyle,
  linkAdd,
} from '../../../../components/MessageEditor';
import {
  editorLinkModalDataSelector,
  editorStateSelector,
  messageAreaStateSelector,
} from '../../store/selectors';
import {
  setEditorState,
  setIsHtml,
  setEditorLinkModalData,
  setMessageAreaState,
  setEditorPhoneModalData,
} from '../../store/actions';
import styles from './PostMessageForm.module.scss';

const AreaBlock = () => {
  const { getState, dispatch } = useStore();
  const { loading } = useSubmit();

  useEffect(() => {
    const editorState = editorStateSelector(getState());
    const content = editorState.getCurrentContent().getPlainText();
    dispatch(setMessageAreaState(content));
  }, [getState, dispatch]);

  return (
    <MessageArea
      className={styles.textarea}
      disabled={loading}
    />
  );
};

const EditorBlock = () => {
  const { getState, dispatch } = useStore();

  useEffect(() => {
    const textArea = messageAreaStateSelector(getState());

    const contentState = ContentState.createFromText(textArea);
    const rawEditorState = EditorState.createWithContent(
      contentState,
      decorators(
        setEditorLinkModalData,
        setEditorState,
        editorStateSelector,
        setEditorPhoneModalData
      )
    );

    const rawSelection = rawEditorState.getSelection();
    const selection = rawSelection.merge({
      anchorOffset: textArea.length,
      focusOffset: textArea.length,
    });

    const editorState = EditorState.forceSelection(rawEditorState, selection);
    dispatch(setEditorState(editorState));
  }, [getState, dispatch]);

  return (
    <MessageEditor
      className={styles.editor}
      editor={{ editorStateSelector, setEditorState }}
      toolbarCreate={[inlineStyle, blockHeading, blockList, linkAdd]}
      closeEditor={{ setCloseEditor: setIsHtml, closeBtn: true }}
      linkModal={{ setEditorLinkModalData, editorLinkModalDataSelector }}
    />
  );
};

const MessageBlock = ({ isHtml }) => {
  return isHtml ? <EditorBlock /> : <AreaBlock />;
};

export default MessageBlock;
